<template>
    <div>
        demo

        <h1  v-hasPermi="['system:user:add']">aaaa</h1>
        <h1  v-hasPermi="['system:user:add']">bbbb</h1>
        <h1 >ccc</h1>
    </div>
</template>

<script setup name="demo">
    
</script>